import { NUMBER, STRING, DATE } from 'shared/constants/InvoiceFiltersTypes';

const END_DATE = 'End Date';
const START_DATE = 'Start Date';

export const isFilterValid = filter => {
  const numericRegEx = /^$|^[+-]?\d+(\.\d+)?$/;
  if (filter.data.type === NUMBER) {
    if ( parseInt(filter.data.min.value, 10) > parseInt(filter.data.max.value, 10) ) {
      return 'The minimum value cannot exceed the maximum value';
    }
    if ( !filter.data.min.value.match(numericRegEx) || !filter.data.max.value.match(numericRegEx) ) {
      return 'Not a valid numeric format';
    } else {
      return '';
    }
  }
};

export const reformatDate = dateValue => {
  const splittedDate = `${dateValue}`.split(/-/);
  const reformattedDate = [
    splittedDate[2],
    splittedDate[0],
    splittedDate[1]
  ].join('');
  return reformattedDate;
};

const setInvoiceFilter = (
  invFilter,
  disabled,
  filterValidationError,
  value,
  collapsed
) => ({
  ...invFilter,
  disabled: disabled,
  filterValidationError: filterValidationError,
  data: { ...invFilter.data, value: value },
  collapsed: collapsed || invFilter.collapsed
});

export const clearFilter = (filters, collapsedFilter) => {
  const startDateValue = filters.find(filter => filter.title === START_DATE)
    .data.value;
  return filters.map(invFilter => {
    if (
      collapsedFilter.data.type === STRING ||
      collapsedFilter.data.type === DATE
    ) {
      if (
        collapsedFilter.title === END_DATE &&
        invFilter.title === END_DATE &&
        startDateValue === ''
      ) {
        return setInvoiceFilter(
          invFilter,
          true,
          'The start date should be selected',
          '',
          true
        );
      }
      if (
        collapsedFilter.title === START_DATE &&
        invFilter.title === END_DATE
      ) {
        return setInvoiceFilter(
          invFilter,
          true,
          'The start date should be selected',
          ''
        );
      }

      if (
        collapsedFilter.title === END_DATE &&
        invFilter.title === END_DATE &&
        startDateValue !== ''
      ) {
        return setInvoiceFilter(invFilter, false, '', '', true);
      }
      if (invFilter.data.key === collapsedFilter.data.key) {
        return setInvoiceFilter(invFilter, false, '', '', true);
      }
    }
    if (
      collapsedFilter.data.type === NUMBER &&
      invFilter.data.type === NUMBER
    ) {
      if (
        invFilter.data.max.key === collapsedFilter.data.max.key ||
        invFilter.data.min.key === collapsedFilter.data.min.key
      ) {
        return {
          ...invFilter,
          filterValidationError: '',
          data: {
            ...invFilter.data,
            max: { ...invFilter.data.max, value: '' },
            min: { ...invFilter.data.min, value: '' }
          },
          collapsed: true
        };
      }
    }
    return { ...invFilter };
  });
};



// WEBPACK FOOTER //
// ./src/shared/helpers/filterValidationHelper.js